// Chairs.js
import React, { use, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectChairsObject } from "../../../store/Chairs/ChairsSlice"
import { selectAvatarsArray } from "../../../store/Avatars/AvatarsSlice";
import Avatar from './Avatar';
import { setFocusedAvatarId } from '../../../store/MapDisplaySlice';

const Avatars = ({ avatarBounds, mapRef, onCenterMap , mapConfig ,zoomLevel }) => {
  const dispatch = useDispatch()
  const { avatars, loading, error } = useSelector((state) => state.avatars);
  const { focusedAvatarId } = useSelector((state) => state.MapDisplay)
  const overlays = useRef({})
  const chairsObject = useSelector(selectChairsObject);
  const avatarsList = useSelector(selectAvatarsArray);


  useEffect(() => {
    // cycle through avatar entries
    // if an avatar is in the overlay, but not in the avatars object, remove it
    Object.keys(overlays.current).forEach((overlayId) => {
      const avatarId = overlayId.split('-')[1];
      if (!avatars[avatarId]) { // Direct O(1) lookup instead of O(n) search
        overlays.current[overlayId].remove();
        delete overlays.current[overlayId];
      }
    });
  }, [avatars]);


  // Hook for focusing on the focused avatar. 
  useEffect(() => {
    if (focusedAvatarId && mapRef.current && avatars[focusedAvatarId] && chairsObject[avatars[focusedAvatarId].chair_id] && overlays.current[`avatar-${focusedAvatarId}`]) {
      try {
        const focusedAvatar = avatars[focusedAvatarId];
        const focusedChair = chairsObject[focusedAvatar?.chair_id]
        if (focusedChair) {
          onCenterMap(focusedChair);
          dispatch(setFocusedAvatarId(null));
        }
      } catch (error) {
        console.error("Error while focusing on avatar ", focusedAvatarId)
        dispatch(setFocusedAvatarId(null));
      }
    }
  }, [focusedAvatarId, chairsObject, avatars])

  return (
    <>
      {avatarsList.map((avatar) => (
        <Avatar
          key={avatar.id}
          chair={chairsObject[avatar.chair_id]}
          avatar={avatar}
          avatarBounds={avatarBounds}
          mapRef={mapRef}
          overlays={overlays}
          mapConfig={mapConfig}
          zoomLevel={zoomLevel}
        />
      ))}
    </>
  );
};

export default Avatars;